module.exports = __webpack_public_path__ + "img/empty-state.dbc59108.svg";